import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Paper,
  Stack,
  CircularProgress,
} from '@mui/material';
import { useMutation, gql } from '@apollo/client';
import UploadIcon from '@mui/icons-material/FileUpload';

const INITIALIZE_IMPORT = gql`
  mutation InitializePricelistImport($articlePriceListId: ID!, $companyId: ID!, $action: String!) {
    initializePricelistImport(articlePriceListId: $articlePriceListId, companyId: $companyId, action: $action) {
      uploadUrl
      sessionId
    }
  }
`;

export default function PricelistImportDialog({ open, onClose, companyId, articlePriceListId, onImported }) {
  const [action, setAction] = useState('update');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [initializeImport] = useMutation(INITIALIZE_IMPORT);

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
  };

  const handleSubmit = async () => {
    if (!file || !articlePriceListId) return;
    setUploading(true);
    try {
      const { data } = await initializeImport({
        variables: { articlePriceListId, companyId, action },
      });
      const uploadUrl = data?.initializePricelistImport?.uploadUrl;
      if (!uploadUrl) throw new Error('No upload URL returned');

      const formData = new FormData();
      formData.append('file', file);

      await fetch(uploadUrl, {
        method: 'POST',
        body: formData,
      });

      setUploading(false);
      if (onImported) onImported();
      onClose();
    } catch (err) {
      console.error(err);
      setUploading(false);
      alert('Import misslyckades');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Importera prislista</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="subtitle1">Här kan du importera en prislista från en Excel-fil.</Typography>
          <Typography variant="body2">Filen ska ha samma format som exportfilen från prislistor.</Typography>

          <Typography variant="subtitle2">Åtgärd</Typography>
          <RadioGroup row value={action} onChange={(e) => setAction(e.target.value)}>
            <FormControlLabel value="update" control={<Radio />} label="Uppdatera prislistan" />
            <FormControlLabel value="replace" control={<Radio />} label="Ersätt prislistan" />
          </RadioGroup>

          <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>
            <Typography>Släpp en Excel-fil här eller välj en fil</Typography>
          </Paper>

          <input type="file" accept=".xlsx,.xls" onChange={handleFileChange} />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Avbryt</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!file || uploading} startIcon={uploading ? <CircularProgress size={16} /> : <UploadIcon />}>
          {uploading ? 'Importerar...' : 'Importera'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
